<script>
export default {
  render() {
    return '';
  },
  props: {
    label: {
      type: String
    },
    value: {
      type: String
    },
    name: {
      type: String
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    var value = this.value == null ? this.label : this.value;

    if (typeof this.$parent.options != 'undefined') {
      this.$parent.options.push({
        value: value,
        label: this.label
      });
      if (this.selected)
        this.$parent.value = value;
    }
  }
}
</script>
